import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Testimonials() {
  return <div className="bg-sage-light/20 border-y border-beige-muted/50" data-id="element-209">
      <Section data-id="element-210">
        <SectionTitle data-id="element-211">Lo que dicen las mamás que ya lo aplicaron</SectionTitle>
        <p className="text-center text-charcoal-light mb-12 max-w-2xl mx-auto" data-id="element-212">
          Resultados reales. Familias reales. En pocos días.
        </p>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-213">
          {/* Card 1 — Classic */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-214">
            <div className="flex items-center gap-4 mb-4" data-id="element-215">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-216">
                <span className="text-white font-bold text-sm" data-id="element-217">VR</span>
              </div>
              <div data-id="element-218">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-219">
                  Valentina Rodríguez
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-220">
                  Mamá de Emilio, 6 meses — Córdoba · Con lactancia
                </p>
              </div>
            </div>

            <div className="inline-flex self-start bg-cta/10 text-cta text-sm font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-221">
              De 6 despertares a 1 — en 10 días
            </div>

            <div className="flex gap-1 mb-4" data-id="element-222">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-223" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-224">
              "Yo pensaba que era normal que mi bebé se despertara cada 2 horas.
              Después de aplicar el método, en 10 días pasó a dormir 5 horas
              seguidas. No lo puedo creer todavía."
            </p>
          </div>

          {/* Card 2 — WhatsApp Style */}
          <div className="bg-[#F0EDE8] rounded-2xl shadow-sm border border-beige-muted/50 overflow-hidden flex flex-col" data-id="element-225">
            {/* WhatsApp Header */}
            <div className="bg-[#075E54] px-5 py-3 flex items-center gap-3" data-id="element-226">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-227">
                <span className="text-white text-xs font-bold" data-id="element-228">LC</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-229">
                <span className="text-white font-medium text-sm" data-id="element-230">
                  Luciana C.
                </span>
                <div className="w-2 h-2 rounded-full bg-green-400" data-id="element-231"></div>
              </div>
            </div>

            {/* Message Area */}
            <div className="p-5 flex-1" data-id="element-232">
              <div className="bg-white rounded-2xl rounded-tl-sm p-4 shadow-sm max-w-[95%] relative" data-id="element-233">
                <p className="text-charcoal text-[15px] leading-relaxed" data-id="element-234">
                  Chicas les cuento que llevamos 12 días con el método y Martina
                  (9 meses) ya duerme su primera siesta de corrido. Ayer a la
                  noche se despertó UNA sola vez. Estoy llorando de emoción 😭
                </p>
                <div className="flex justify-end mt-2" data-id="element-235">
                  <span className="text-xs text-charcoal-light/60" data-id="element-236">
                    14:32 ✓✓
                  </span>
                </div>
              </div>

              <p className="text-xs text-charcoal-light/60 mt-3 ml-1" data-id="element-237">
                Hace 3 días
              </p>
            </div>

            {/* Footer Label */}
            <div className="px-5 pb-4" data-id="element-238">
              <p className="text-sm text-charcoal-light" data-id="element-239">
                Luciana — Buenos Aires
              </p>
            </div>
          </div>

          {/* Card 3 — Classic */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-240">
            <div className="flex items-center gap-4 mb-4" data-id="element-241">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-242">
                <span className="text-white font-bold text-sm" data-id="element-243">SM</span>
              </div>
              <div data-id="element-244">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-245">
                  Sofía Méndez
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-246">
                  Mamá de Tomás, 11 meses — Rosario · Sin lactancia
                </p>
              </div>
            </div>

            <div className="inline-flex self-start bg-cta/10 text-cta text-sm font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-247">
              Primera noche completa — día 8
            </div>

            <div className="flex gap-1 mb-4" data-id="element-248">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-249" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-250">
              "Mi hijo no dormía toda la noche y yo estaba agotada. Esto nos
              devolvió la paz en casa. Vale cada peso."
            </p>
          </div>
        </div>
      </Section>
    </div>;
}